import Styles from './UploadsDrawer.module.scss'
import { Carousel } from 'components/Carousel/Carousel'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

interface Props {
  count?: number
}

export const LoadingCarousel = ({ count = 3 }: Props) => {
  return (
    <Carousel slideGap={7}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className={Styles.placeholderContainer}>
          <LoadingShimmerer className={Styles.placeholder} borderRadius={6} />
        </div>
      ))}
    </Carousel>
  )
}
